import { useTranslator } from '@Localization';
import { useInjection } from 'inversify-react';
import { checkAll, checkWorkspaceRole, IPermissionCheckResult } from '../../../modules/permissions/permissionsHelpers';
import { ICurrentWorkspaceStore } from '../../../modules/workspaces/currentWorkspace/CurrentWorkspace.store';
import { Plan } from '../user/user.store';
import { WorkspaceRole } from '../workspaces/workspaces.store';

interface ITeamPermissions {
  canSeeOwnerErrors(): IPermissionCheckResult;
  canViewTeamMembers(): IPermissionCheckResult;
  canManageTeamMembers(): IPermissionCheckResult;
  canAddTeamMembers(): IPermissionCheckResult;
}

export const useTeamPermissions = (): ITeamPermissions => {
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);
  const currentWorkspace = currentWorkspaceStore.currentWorkspace;
  const { t } = useTranslator();

  const canSeeOwnerErrors = (): IPermissionCheckResult => {
    return checkWorkspaceRole([WorkspaceRole.Owner], currentWorkspace, t);
  };

  const canViewTeamMembers = (): IPermissionCheckResult => {
    return checkAll(
      [Plan.Admin, Plan.Annotation, Plan.Training, Plan.Inactive],
      [WorkspaceRole.Owner, WorkspaceRole.Manager, WorkspaceRole.Developer, WorkspaceRole.Trainer],
      currentWorkspace,
      t
    );
  };

  const canManageTeamMembers = (): IPermissionCheckResult => {
    return checkAll([Plan.Admin, Plan.Annotation, Plan.Training], [WorkspaceRole.Owner, WorkspaceRole.Manager], currentWorkspace, t);
  };

  const canAddTeamMembers = (): IPermissionCheckResult => {
    return checkAll([Plan.Admin, Plan.Annotation, Plan.Training], [WorkspaceRole.Owner, WorkspaceRole.Manager], currentWorkspace, t);
  };

  return {
    canSeeOwnerErrors,
    canViewTeamMembers,
    canManageTeamMembers,
    canAddTeamMembers,
  };
};
